import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux';
import { AnimationWrapper } from './views/animate';
import { HomeBuying } from './views/HomeBuying';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Provider store={store}>
		<AnimationWrapper>
			<Background />
			<HomeBuying />
		</AnimationWrapper>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.HomeBuying)
	.setTransitionTime(600)
	.build();

export default Layout;
